module.exports = __webpack_public_path__ + "static/media/ic_heat.6c2278f5.png";